import { ReactNode } from 'react';
import { labelStyle } from 'modules/Models/components/ModelForm/styles';
import startCase from 'lodash/startCase';
import { TEXT_GEN_MODEL_TYPES } from 'modules/Models/types';
import { useFormikContext } from 'formik';
import { FormikInitialValues } from '../../../utils/types';

type FormLabelProps = { path: string; description?: ReactNode; required?: boolean };

export const FormLabel = ({ path, description, required }: FormLabelProps): JSX.Element | null => {
  const splitPath = path.split('.');
  const formLabelTitle = splitPath[splitPath.length - 1];
  const formattedTitle = startCase(formLabelTitle.replace('_', ' '));
  const { values } = useFormikContext();
  const { modelType } = values as FormikInitialValues;
  const isTextGenView = TEXT_GEN_MODEL_TYPES.includes(modelType);

  return (
    <label className={labelStyle} htmlFor={path}>
      <div id={`${path}-label`} className="form-label">
        {formattedTitle} {required && <span className="label-required-field">*</span>}
      </div>
      {!isTextGenView && description && <div className="label-description">{description}</div>}
    </label>
  );
};
